import { render, staticRenderFns } from "./NoPermsPage.vue?vue&type=template&id=f05500f4"
import script from "./NoPermsPage.vue?vue&type=script&lang=js"
export * from "./NoPermsPage.vue?vue&type=script&lang=js"
import style0 from "./NoPermsPage.vue?vue&type=style&index=0&id=f05500f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports